import { type Meta } from '../types/docs';
import { AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM } from './automationsAnalytics';

const META: Meta = {
  description: 'The user deletes an automation',
  name: 'automation_deleted',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation that was deleted',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
